import React, { useContext, useEffect, useRef, useState } from "react";
import { ERROR_MESSAGES } from "../../../components/common/GlobalMassssage";
import {
  GetAddUpdateUserRole,
  GetRoleTypeModel,
} from "../../../services/UserRole/UserRoleApi";
import SuccessModal from "../../../components/common/SuccessModal";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";
import {
  AddUpdateCustomerIndustry,
  GetCustomerIndustryModel,
} from "../../../services/CustomerIndustry/CustomerIndustryApi";

const AddUpdateCustomerIndustryModal = ({
  isOpen,
  onClose,
  setIsAddUpdateDone,
  modelRequestData,
}) => {
  const inputRef = useRef(null);
  const ModuleName = "Predefined";
  const [customerIndustryName, setCustomerIndustryName] = useState("");
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
    }
  }, [isOpen]);

  //getModel
  useEffect(() => {
    setModelAction(modelRequestData.Action === null ? "Add" : "Update"); //Do not change this naming convention
    if (
      modelRequestData.KeyID !== undefined &&
      modelRequestData.KeyID !== null &&
      modelRequestData.Action === "Update"
    ) {
      GetUserRoleModelData(modelRequestData.KeyID);
    } else {
      setCustomerIndustryName("");
    }
    setErrorMessage("");
  }, [modelRequestData]);
  if (!isOpen) return null;

  //Get Model
  const GetUserRoleModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetCustomerIndustryModel(
      ModuleName,
      KeyID,
      authDetails.adminKeyID
    );
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      setCustomerIndustryName(ModalData.customerIndustryName);
    } else {
      setLoader(false);
    }
  };
  const handleRoleType = async () => {
    if (
      customerIndustryName === undefined ||
      customerIndustryName === null ||
      customerIndustryName === ""
    ) {
      setRequireErrorMessage(true);
      return false;
    }
    setLoader(true);
    try {
      const data = await AddUpdateCustomerIndustry({
        adminKeyID: authDetails.adminKeyID,
        customerKeyID: authDetails.customerKeyID,
        customerIndustryName: customerIndustryName,
        CustomerIndustryKeyID: modelRequestData.KeyID,
        ModuleName: ModuleName,
      });
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
        setShowSuccessPopupModal(true);
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={onClose}
      aria-hidden={!isOpen}
    >
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-md"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        {/* Modal Header */}
        <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
          <h2 className="text-16 font-semibold">
            {modelAction} Customer Industry
          </h2>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
            aria-label="Close Modal"
          >
            ✕
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-6 grid grid-cols-1 gap-4">
          {/* Role Name Input */}
          <div className="mb-4 w-full">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Customer Industry Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              maxLength={50}
              className="w-full p-2 border rounded-md text-12"
              placeholder="Enter Customer Industry Name"
              value={customerIndustryName}
              onChange={(e) => {
                let value = e.target.value;

                // Capitalize the first letter if the input is not empty
                if (value.length > 0) {
                  value = value.charAt(0).toUpperCase() + value.slice(1);
                }

                // Allow only letters at the start, then letters & spaces after the first character
                if (/^[A-Za-z][A-Za-z\s]*$/.test(value) || value === "") {
                  setCustomerIndustryName(value);
                }
              }}
            />
            {requireErrorMessage &&
            (customerIndustryName === "" ||
              customerIndustryName === undefined ||
              customerIndustryName === null) ? (
              <label className="validation">{ERROR_MESSAGES}</label>
            ) : (
              ""
            )}
          </div>
        </div>
        {errorMessage && (
          <div className="text-center m-2">
            <label className="validation ">{errorMessage}</label>
          </div>
        )}
        {/* Modal Footer */}
        <div className="bg-gray-100 px-6 py-4 border-t flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 bg-gray-300 rounded-md text-12"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            onClick={() => handleRoleType()}
            className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12"
          >
            Submit
          </button>
        </div>
      </div>

      <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => setShowSuccessPopupModal(false)}
        modelAction={modelAction}
        actionMessage={customerIndustryName}
      />
    </div>
  );
};

export default AddUpdateCustomerIndustryModal;
